import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "DO benchmark yourself against normal",
  "description": "",
  "published": "2012-09-04T00:00:00.000Z",
  "redirect_from": ["/blog/do-benchmark-yourself-against-normal/swizec/5222"],
  "categories": "Gauss, HackerNews, Steampunk Magazine, Uncategorized, Zemanta, Zuckerberg",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.signalgallery.com/shop/aggression-competition-ambition-1"
      }}><img parentName="a" {...{
          "src": "https://www.signalgallery.com/img/product_images/image/largeone/1648-aggression-competition-ambition-839-840.JPG",
          "alt": "Aggression, Competition, Ambition",
          "title": "Aggression, Competition, Ambition"
        }}></img></a></p>
    <p><em parentName="p"><a parentName="em" {...{
          "href": "http://www.sebastianmarshall.com/dont-benchmark-yourself-against-normal"
        }}>{`Don't Benchmark Yourself Against Normal`}</a></em>{` was making rounds on HN this morning. I've expressed the gist of what I'm about to say in a `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/item?id=4473429"
      }}>{`comment`}</a>{`, but I can't get the damn thing out of my mind. There's more to say.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Benchmarking against normal sets the bar way too low. Benchmark against your own potential, and against your desires. You get less “self-pats-on-the-back,” but you’ll live a much more thrilling life.`}</p>
    </blockquote>
    <p>{`You know what? Taking the time off now and then to benchmark against normal is the only thing that keeps me sane. The only thing that reminds me I `}<em parentName="p">{`don't`}</em>{` have to feel like a 24 year old (turning 25 in about a month) underachieving loser.`}</p>
    <p><img parentName="p" {...{
        "src": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Richard_Feynman_-_Fermilab.jpg/300px-Richard_Feynman_-_Fermilab.jpg",
        "alt": "English: at",
        "title": "English: at"
      }}></img></p>
    <p>{`Think about it, Turing published the turing machine paper when he was 24, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Carl_Friedrich_Gauss",
        "title": "Carl Friedrich Gauss"
      }}>{`Gauss`}</a>{` was a prominent mathematician by 21, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Richard_Feynman",
        "title": "Richard Feynman"
      }}>{`Feynman`}</a>{` was laying the groundwork for important quantum physics stuff at 24, Wilde published a book at 27 - after having published things in magazines for 10 years - `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Neil_gaiman"
      }}>{`Gaiman`}</a>{`'s published his first professional fiction piece at 24 and all three of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Zuckerberg",
        "title": "Zuckerberg"
      }}>{`Zuckerberg`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Steve_jobs"
      }}>{`Jobs`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Bill_gates"
      }}>{`Gates`}</a>{` were very successful entrepreneurs by the time they hit 24. `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Muhammad_Ali"
      }}>{`Ali`}</a>{` was heavyweight champion of the world at 22.`}</p>
    <p>{`Hell, even many of my friends have already published papers (plural), some are even running successful businesses. Some have founded both cool startups `}<em parentName="p">{`and`}</em>{` awesome non-profits. Some of these friends are even my age, or at least were when they did the cool things I'm talking about.`}</p>
    <p>{`You could say comparing yourself to others is no way to lead a happy life and is a recipe for fail.`}</p>
    <p>{`Comparing to myself is no better. By now I should have:`}</p>
    <ul>
      <li parentName="ul">{`published a novel or two`}</li>
      <li parentName="ul">{`contributed something significant to computer science`}</li>
      <li parentName="ul">{`successfully launched a VC-backed startup into the stratosphere`}</li>
      <li parentName="ul">{`long since finished college`}</li>
    </ul>
    <p>{`And none of this is even that crazy. I've certainly attempted all of those things and ultimately managed to fail at every each one of them. Every single thing.`}</p>
    <p>{`Comparing myself to others or to my own ambitions, therefore, is no way to feel good about myself or build the `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/entrepreneurs-this-is-how-much-confidence-you-need/swizec/5102"
      }}>{`confidence needed to achieve great things`}</a>{`.`}</p>
    <p>{`But then I take a step back and remember that:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`a lot`}</em>{` of people don't even go to college`}</li>
      <li parentName="ul">{`many who do, drop out within the first year or two and never go back`}</li>
      <li parentName="ul">{`many people my age are already having kids - feels like a huge waste of potential when a bright person decides to take up child rearing before doing anything cool with their brains`}</li>
      <li parentName="ul">{`most people haven't been published in a printed magazine at ~17 (issue #3 of `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Steampunk_Magazine",
          "title": "Steampunk Magazine"
        }}>{`Steampunk Magazine`}</a>{`, pen name von Tropp)`}</li>
      <li parentName="ul">{`few owned some of the most downloaded plugins for a popular OSS platform at ~18 (mods for phpBB2)`}</li>
      <li parentName="ul">{`most people haven't both founded and face-planted a startup by 23`}</li>
      <li parentName="ul">{`few have `}<a parentName="li" {...{
          "href": "http://swizec.com/blog/postme-me-idea-to-sales-in-3-days/swizec/2690"
        }}>{`launched a project and gotten sales in 3 days`}</a></li>
      <li parentName="ul">{`not everyone's got a blog with monthly readership in the thirty thousands`}</li>
      <li parentName="ul">{`not everyone can write articles on random topics that semi-reliably garner 20k+ visits in a day (my `}<a parentName="li" {...{
          "href": "http://zemanta.com/fruitblog"
        }}>{`blogging for Zemanta`}</a>{`)`}</li>
      <li parentName="ul">{`most people couldn't save their own lives -> `}<em parentName="li"><a parentName="em" {...{
            "href": "http://swizec.com/blog/why-you-dont-exercise-every-day/swizec/3456"
          }}>{`Why you don't exercise every day`}</a></em></li>
    </ul>
    <p>{`This post is devolving into bragging so I'll stop.`}</p>
    <p>{`My point is, if you're the average `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`HackerNews`}</a>{` reader, please for the love of god, compare yourself to normal people now and then. Remember that the person you are aspiring to be is in the top 0.1% of one or more fields.`}</p>
    <p>{`Cut yourself some slack, all is not lost.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.sebastianmarshall.com/dont-benchmark-yourself-against-normal"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_77_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.sebastianmarshall.com/dont-benchmark-yourself-against-normal"
        }}>{`Don't Benchmark Yourself Against Normal`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://hacks.mozilla.org/2012/08/no-single-benchmark-for-the-web/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_3_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "https://hacks.mozilla.org/2012/08/no-single-benchmark-for-the-web/"
        }}>{`No Single Benchmark for the Web`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://markmaunder.com/2012/07/28/how-to-be-happy/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_83_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://markmaunder.com/2012/07/28/how-to-be-happy/"
        }}>{`How to avoid being unhappy and how to find happiness.`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://classoneforty.wordpress.com/2012/09/04/alan-turing-the-tech-worlds-hero-and-why-he-should-be-a-household-name/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/110203365_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://classoneforty.wordpress.com/2012/09/04/alan-turing-the-tech-worlds-hero-and-why-he-should-be-a-household-name/"
        }}>{`Alan Turing, the tech world's hero and why he SHOULD be a household name`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5c18b3cd-097c-4619-a03c-698aaee43ef8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      